import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PublicIcon from '@mui/icons-material/Public';
import { Avatar, Button, IconButton, Paper, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DropdownItem } from '../../../sic-lib/types/WebPush';

interface NotificationProps {
    website: string;
    title: string;
    message?: string;
    iconSrc: string;
    onClose: () => void;
    buttons?: string[];
    siteItems: DropdownItem[];
}

export const WebPushNotification: React.FC<NotificationProps> = ({
    title = 'Title',
    message = 'Message',
    iconSrc,
    onClose,
    website = 'www.example.com',
    buttons = [],
    siteItems,
}) => {
    const { classes } = useStyles();
    return (
        <Paper elevation={6} className={classes.paper}>
            <div className={classes.header}>
                <Avatar className={classes.chromeLogo}>
                    <PublicIcon />
                </Avatar>
                <Typography variant="subtitle2">Google Chrome</Typography>
            </div>
            <div className={classes.content}>
                <Avatar variant="square" src={iconSrc} className={classes.favicon} />
                <div className={classes.textContent}>
                    <Typography variant="subtitle1" noWrap>
                        {title}
                    </Typography>
                    <Typography variant="body2">{message}</Typography>
                    <Typography variant="caption" component="p" noWrap color="textSecondary">
                        {siteItems.find(itm => itm.id === website)?.label.split('(External)')[0]}
                    </Typography>
                </div>
            </div>
            <div className={classes.buttons}>
                {buttons.map((label, index) => (
                    <Button key={index} variant="outlined" className={classes.button}>
                        {label}
                    </Button>
                ))}
            </div>
            <IconButton className={classes.menuButton}>
                <MoreHorizIcon fontSize="inherit" />
            </IconButton>
            <IconButton className={classes.closeButton} onClick={onClose}>
                <CloseIcon fontSize="inherit" />
            </IconButton>
        </Paper>
    );
};

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        width: 340,
        borderRadius: 0,
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    chromeLogo: {
        width: 20,
        height: 20,
        marginRight: theme.spacing(1),
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    favicon: {
        width: 55,
        height: 55,
        marginRight: theme.spacing(2),
    },
    textContent: {
        flexGrow: 1,
        minWidth: 0,
    },
    buttons: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        gap: 2,
    },
    button: {
        width: '100%',
    },
    menuButton: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(4),
        width: 20,
        height: 20,
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        width: 20,
        height: 20,
    },
}));
